export function taskCountLabel(status) {
  const key = String(status || '').toLowerCase()
  if (key === 'all') return 'All Items'
  if (['resolved', 'complete', 'done', 'closed'].includes(key)) return 'Resolved Items'
  if (key === 'approved_or_complete') return 'Approved / Completion Items'
  return 'Open Items'
}
